'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _accounts = require('ifeis-isomorphic/lib/redux/actions/accounts');

var _getFeatureFlags = require('../../../isomorphic/lib/redux/actions/feature-flags/getFeatureFlags');

exports.default = angular.module('ifeis.session', []).factory('fSession', function ($q, $location, $ngRedux) {
  var _user;

  var promise = void 0;
  var sessionVersion = 0;

  var updateUser = function updateUser(newUser) {
    _user = newUser;
    localStorage.setItem('firstName', _user.fname);
    localStorage.setItem('lastName', _user.lname);
    localStorage.setItem('userId', _user.id);
    return _user;
  };

  var getUser = function getUser() {
    var version = sessionVersion;
    return promise = $ngRedux.dispatch((0, _accounts.getMyAccount)()).then(function (response) {
      if (!response.payload || version !== sessionVersion) {
        return $q.reject();
      }

      _user = response.payload;
      localStorage.setItem('firstName', _user.fname);
      localStorage.setItem('lastName', _user.lname);
      localStorage.setItem('userId', _user.id);
      return _user;
    });
  };

  getUser();

  return {
    _login: function _login(response) {
      var _this = this;

      $ngRedux.dispatch((0, _getFeatureFlags.getFeatureFlags)()).then(function (flagResponse) {
        if (flagResponse.payload && flagResponse.payload.flags.isCrossNavigationEnabled) {
          var url = IFEIS_APPV2_URI + '/feiseanna-list';
          window.location.href = url;
        } else {
          localStorage.setItem('jwt', JSON.stringify(response));

          return _this.refresh().then(function (userResponse) {
            _user = userResponse;
            var path = localStorage.getItem('IFEIS_REDIRECT_URL') || '/dashboard';

            if (!_user.fname || !_user.lname) {
              path = "/profile";
            }

            localStorage.removeItem('IFEIS_REDIRECT_URL');
            $location.url(path);
          });
        }
      });
    },
    logOut: function logOut() {
      // FIXME(jdm): this should also clear out all stores, but without injecting them here.
      sessionVersion++;
      _user = null;
      localStorage.removeItem('jwt');
      localStorage.removeItem('firstName');
      localStorage.removeItem('lastName');
      localStorage.removeItem('userId');
      $location.path('/');
    },


    isLoggedIn: function isLoggedIn() {
      return !!_user;
    },

    isGod: function isGod() {
      return _user && _user.is_god === 1;
    },

    refresh: function refresh() {
      return getUser();
    },


    update: function update(user) {
      return updateUser(user);
    },

    user: function user() {
      var defer = $q.defer();
      promise = promise.then(function (u) {
        if (_user) {
          defer.resolve(_user);
        } else {
          defer.reject();
        }

        return u;
      });

      return defer.promise;
    }
  };
}).config(function ($httpProvider) {
  $httpProvider.interceptors.push(function ($q) {

    return {
      'request': function request(config) {
        var jwt = localStorage.getItem('jwt');

        try {
          jwt = JSON.parse(localStorage.getItem('jwt'));
        } catch (e) {
          console.debug('Not authenticated');
        }

        if (!jwt || !jwt.token) {
          return config;
        }

        if (!config.headers) {
          config.headers = {};
        }

        if (!config.noAuth) {
          config.headers['Authorization'] = 'JWT ' + jwt.token;
        }

        return config;
      }
    };
  });
});


//////////////////
// WEBPACK FOOTER
// ./session/index.js
// module id = 60
// module chunks = 0